import React from 'react'
import { Checkbox as HeadlessCheckbox } from '@headlessui/react'
import clsx from 'clsx'
import CheckmarkIcon from '@/shared/icons/CheckmarkIcon'

const Checkbox = ({
  checked,
  onChange,
  disabled = false,
  className = '',
  checkboxClassName = '',
  label,
  indeterminate = false, // New prop for indeterminate state
  ...props
}) => {
  return (
    <div className={clsx('flex items-center gap-v3-xs rounded-[6px]', className)}>
      <HeadlessCheckbox
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={clsx(
          'group',
          'w-5',
          'h-5',
          'rounded-[6px]',
          'border',
          'border-v3-black-inactive',
          'bg-white',
          'flex',
          'items-center',
          'justify-center',
          'transition-all',
          'duration-200',
          'data-[checked]:bg-v3-purple-primary',
          'data-[checked]:border-v3-purple-primary',
          'hover:border-v3-purple-primary',
          'disabled:opacity-50',
          'disabled:cursor-not-allowed',
          'disabled:hover:border-v3-black-inactive',
          'cursor-pointer',
          // Indeterminate state styling
          indeterminate && !checked && 'bg-v3-purple-primary border-v3-purple-primary',
          'flex-shrink-0',
          checkboxClassName
        )}
        {...props}
      >
        {/* Show checkmark when checked, horizontal line when indeterminate */}
        {checked && !indeterminate && (
          <CheckmarkIcon className="block text-white" />
        )}
        {indeterminate && !checked && (
          <div className="w-3 h-0.5 bg-white" />
        )}
      </HeadlessCheckbox>
      {label && (
        <label
          className={clsx(
            'text-v3-h10',
            'text-v3-black-max',
            'cursor-pointer',
            'flex-1',
            'break-words',
            disabled && 'opacity-50 cursor-not-allowed'
          )}
          onClick={(e) => {
            if (!disabled && onChange) {
              e.preventDefault()
              onChange(!checked)
            }
          }}
        >
          {label}
        </label>
      )}
    </div>
  )
}

export default Checkbox

